import { defineStore } from "pinia";

export const useAppState = defineStore("app-state", {
    state: () => ({
        isLoading: false,
        tevalisUpdating: false,
        menuOpen: false,
    }),
});
